var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "online-course" },
    [
      _vm._l(_vm.dataList, function(item, index) {
        return _c(
          "div",
          { key: index },
          [
            item.path
              ? _c("p", { staticClass: "tit" }, [_vm._v(_vm._s(item.path))])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(item.list, function(dta, idx) {
              return _c(
                "div",
                {
                  key: idx,
                  staticClass: "parent-list",
                  on: {
                    click: function($event) {
                      return _vm.getChild(dta)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "parent" }, [
                    dta.type == 99
                      ? _c("div", { staticClass: "self_class" }, [
                          _c("p", { staticClass: "self_title" }, [
                            _c("span", { staticClass: "self_tag" }, [
                              _vm._v("自助开课")
                            ]),
                            _c("span", { staticClass: "title-msg" }, [
                              _vm._v(_vm._s(dta.name))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "time_limit" }, [
                            _c("p", [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: dta.show_time,
                                      expression: "dta.show_time"
                                    }
                                  ]
                                },
                                [_vm._v(_vm._s(dta.expired))]
                              )
                            ]),
                            _c(
                              "p",
                              {
                                staticClass: "expired",
                                on: {
                                  click: function($event) {
                                    return _vm.go_selfclass(dta.coding)
                                  }
                                }
                              },
                              [
                                _vm._v("请根据需要，选择课程"),
                                _c("span", [_vm._v("去开课")])
                              ]
                            )
                          ])
                        ])
                      : _c("div", [
                          _c("p", [
                            dta.isShow
                              ? _c("img", {
                                  attrs: {
                                    src: require("../../../static/images/arrow-down.png"),
                                    alt: ""
                                  }
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("../../../static/images/arrow-right.png"),
                                    alt: ""
                                  }
                                })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "title-msg" }, [
                            _c("p", [_vm._v(_vm._s(dta.name))]),
                            _vm._v(" "),
                            _c("p", { staticClass: "expired" }, [
                              _vm._v(_vm._s(dta.expired))
                            ])
                          ])
                        ]),
                    _vm._v(" "),
                    dta.isShow
                      ? _c(
                          "div",
                          _vm._l(dta.list, function(data, id) {
                            return _c(
                              "div",
                              { key: id, staticClass: "child-list" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "child",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.getComponents(
                                          data.id,
                                          data,
                                          dta.coding
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("p", [
                                          !data.isShow
                                            ? _c("img", {
                                                attrs: {
                                                  src: require("../../../static/images/arrow-right.png"),
                                                  alt: ""
                                                }
                                              })
                                            : _c("img", {
                                                attrs: {
                                                  src: require("../../../static/images/arrow-down.png"),
                                                  alt: ""
                                                }
                                              })
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "title-msg" },
                                          [
                                            _c("p", [
                                              _vm._v(_vm._s(data.name))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "expired" },
                                              [
                                                _vm._v(
                                                  _vm._s(data.level_count) +
                                                    "个课件 "
                                                ),
                                                _c("span", {
                                                  staticClass: "placeline"
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(data.hour) +
                                                    "课时"
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.componentsList, function(
                                      i,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "components"
                                        },
                                        [
                                          data.isShow
                                            ? _c("div", [
                                                data.id == i.id
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "components-list"
                                                      },
                                                      _vm._l(i.list, function(
                                                        lst,
                                                        listdx
                                                      ) {
                                                        return _c(
                                                          "div",
                                                          { key: listdx },
                                                          [
                                                            lst.children != ""
                                                              ? _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "level_title"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        lst.title
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              lst.children,
                                                              function(
                                                                item,
                                                                dx
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  { key: dx },
                                                                  [
                                                                    item.module_type ==
                                                                      1 ||
                                                                    (item.module_type ==
                                                                      19 &&
                                                                      item.type ==
                                                                        3)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item,
                                                                                  dta.coding
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              0,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "文档"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "placeline"
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          item.file_size
                                                                                        ) +
                                                                                        "M"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                      2 ||
                                                                    (item.module_type ==
                                                                      19 &&
                                                                      item.type ==
                                                                        2)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item,
                                                                                  dta.coding
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              1,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                视频\n                                "
                                                                                    ),
                                                                                    item.video_time
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "placeline"
                                                                                              }
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "formatSeconds"
                                                                                                  )(
                                                                                                    item.video_time
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                      4 ||
                                                                    (item.module_type ==
                                                                      19 &&
                                                                      item.type ==
                                                                        8)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              2,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "试卷"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                      5 ||
                                                                    (item.module_type ==
                                                                      19 &&
                                                                      item.type ==
                                                                        4)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              3,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "练习"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                      6 &&
                                                                    item.is_playback ==
                                                                      1
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item,
                                                                                  dta.coding
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              4,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                回放 "
                                                                                    ),
                                                                                    (_vm.goodsType !=
                                                                                      6 &&
                                                                                      _vm.goodsType !=
                                                                                        10) ||
                                                                                    item.is_show_time
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "placeline"
                                                                                              }
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "timeFormat"
                                                                                                  )(
                                                                                                    item.start_time
                                                                                                  )
                                                                                                ) +
                                                                                                " -\n                                " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "localDateH"
                                                                                                  )(
                                                                                                    item.end_time
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : item.module_type ==
                                                                          6 ||
                                                                        (item.module_type ==
                                                                          19 &&
                                                                          item.type ==
                                                                            6)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item,
                                                                                  dta.coding
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              5,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                直播 "
                                                                                    ),
                                                                                    (_vm.goodsType !=
                                                                                      6 &&
                                                                                      _vm.goodsType !=
                                                                                        10) ||
                                                                                    item.is_show_time
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "placeline"
                                                                                              }
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "timeFormat"
                                                                                                  )(
                                                                                                    item.start_time
                                                                                                  )
                                                                                                ) +
                                                                                                " -\n                                " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "localDateH"
                                                                                                  )(
                                                                                                    item.end_time
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                      7 ||
                                                                    (item.module_type ==
                                                                      19 &&
                                                                      item.type ==
                                                                        7)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item,
                                                                                  dta.coding
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              6,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "讲义夹"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                    9
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              7,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                直播 "
                                                                                    ),
                                                                                    (_vm.goodsType !=
                                                                                      6 &&
                                                                                      _vm.goodsType !=
                                                                                        10) ||
                                                                                    item.is_show_time
                                                                                      ? _c(
                                                                                          "span",
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "placeline"
                                                                                              }
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "timeFormat"
                                                                                                  )(
                                                                                                    item.start_time
                                                                                                  )
                                                                                                ) +
                                                                                                " -\n                                " +
                                                                                                _vm._s(
                                                                                                  _vm._f(
                                                                                                    "localDateH"
                                                                                                  )(
                                                                                                    item.end_time
                                                                                                  )
                                                                                                )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                      19 &&
                                                                    (item.type ==
                                                                      0 ||
                                                                      item.type ==
                                                                        1)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item,
                                                                                  dta.coding
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              8,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "span",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "作业"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "span",
                                                                                      {
                                                                                        staticClass:
                                                                                          "placeline"
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          item.file_size
                                                                                        ) +
                                                                                        "M"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    item.module_type ==
                                                                      20 ||
                                                                    (item.module_type ==
                                                                      19 &&
                                                                      item.type ==
                                                                        20)
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "com-child",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.judgetype(
                                                                                  item,
                                                                                  dta.coding
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              9,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "title"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        item.name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "other-msg"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "模考"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      }),
                                                      0
                                                    )
                                                  : _vm._e()
                                              ])
                                            : _vm._e()
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.handout_flag,
                                        expression: "handout_flag"
                                      }
                                    ],
                                    staticClass: "handout_assembly",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.parent.apply(null, arguments)
                                      }
                                    }
                                  },
                                  [
                                    _c("handoutFile", {
                                      staticClass: "handout_content",
                                      attrs: {
                                        files: _vm.handoutlist,
                                        cid: _vm.handoutcid,
                                        packageid: _vm.handoutpack
                                      },
                                      on: { child: _vm.parent }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]
              )
            })
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.applets_flag && _vm.ios
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { data: _vm.detail, type: 1 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.android
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + 'APP"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.scheme },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c("span", { staticClass: "goapp" }, [
                      _c("a", { on: { click: _vm.search_flag } }, [
                        _vm._v("去APP查看")
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.zujians_flag
        ? _c("goapp", {
            attrs: { data: _vm.detail },
            on: { openapp: _vm.goapp }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "doc",
        attrs: { src: require("../../../static/images/doc.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "video",
        attrs: { src: require("../../../static/images/video.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/write.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/write.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "video",
        attrs: { src: require("../../../static/images/playback.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/zhibo.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "handout",
        attrs: { src: require("../../../static/images/handout.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "write",
        attrs: { src: require("../../../static/images/zhibo.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "doc",
        attrs: { src: require("../../../static/images/doc.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("img", {
        staticClass: "handout",
        attrs: { src: require("../../../static/images/dryRun.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-371e620a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-371e620a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/onlineCourse.vue
// module id = null
// module chunks = 